
define('tpl!ui/contextualPopup/popup', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function";

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n            ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.controls)),stack1 == null || stack1 === false ? stack1 : stack1.done), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.controls)),stack1 == null || stack1 === false ? stack1 : stack1.cancel), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }
function program2(depth0,data) {
  
  
  return "<button class=\"btn btn-info small done\">done</button>";
  }

function program4(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "<a href=\"#\" class=\"btn cancel\" title=\""
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "cancel", options) : helperMissing.call(depth0, "__", "cancel", options)))
    + "\">cancel</a>";
  return buffer;
  }

  buffer += "<div class=\"contextual-popup\" style=\"top:"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.popup)),stack1 == null || stack1 === false ? stack1 : stack1.top)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "px; left:"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.popup)),stack1 == null || stack1 === false ? stack1 : stack1.left)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "px\">\n    <div class=\"arrow\" style=\"left:"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.arrow)),stack1 == null || stack1 === false ? stack1 : stack1.left)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "px\"></div>\n    <div class=\"arrow-cover\" style=\"left:"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.arrow)),stack1 == null || stack1 === false ? stack1 : stack1.leftCover)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "px\"></div>\n    <div class=\"popup-content\">";
  if (helper = helpers.content) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.content); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</div>\n    <div class=\"footer\">\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.controls), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n</div>";
  return buffer;
  });
});

